import { render, staticRenderFns } from "./StepRegras.vue?vue&type=template&id=353bca48&scoped=true"
import script from "./StepRegras.vue?vue&type=script&lang=js"
export * from "./StepRegras.vue?vue&type=script&lang=js"
import style0 from "./StepRegras.vue?vue&type=style&index=0&id=353bca48&prod&scoped=true&lang=css"
import style1 from "./StepRegras.vue?vue&type=style&index=1&id=353bca48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353bca48",
  null
  
)

export default component.exports